import PostModal from 'components/modal/PostModal';
import { Button, Card, Divider, Table, Typography } from 'antd';
import { CommentOutlined } from '@ant-design/icons';
import { IDiscussionThread, IPost } from 'interfaces/discussion_threads';
import { PageHeader } from '../../../components/professor_area/PageHeader';
import { ShowLayout } from '../../../components/layout/layout/ShowLayout';
import { TagField } from '@refinedev/antd';
import { formatDate } from 'services/date';
import { tagColorByStatus } from '../../../utils/statusColorMapping';
import { translateDiscussionStatus } from '.';
import { useModal, useShow } from '@refinedev/core';

const { Title, Text } = Typography;

const onUpdate = () => window.location.reload();

export const DiscussionThreadShow = () => {
  const { queryResult } = useShow<IDiscussionThread>();
  const { data, isLoading } = queryResult;
  const record = data?.data;
  const modal = useModal();

  return (
    <ShowLayout isLoading={isLoading}>
      <PageHeader title="Visualizar dúvida" icon={CommentOutlined} />
      <Card>
        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1 }}>
            <Title level={5}>Disciplina</Title>
            <Text>{record?.grandparent.name}</Text>

            <Title level={5}>Conteúdo</Title>
            <Text>{record?.parent_name || 'Conteúdo Excluído'}</Text>
          </div>

          <div style={{ flex: 1 }}>
            {record?.parent_name && (
              <>
                <Title level={5}> Status</Title>
                <TagField
                  color={tagColorByStatus(record?.status ?? 'unknown')}
                  value={translateDiscussionStatus(record?.status ?? 'unknown')}
                />
              </>
            )}
          </div>
        </div>
        <Divider />

        {record?.posts && (
          <div className="flex-col items-center mt-8">
            <Title level={5}>Registro da conversa</Title>
            <Table dataSource={record?.posts}>
              <Table.Column<IPost>
                title="Nome do autor"
                key="author"
                render={(_, post) => (
                  <Text>
                    {post.author_type === 'User'
                      ? post.author?.full_name_or_name ?? post.author?.name
                      : post.author?.name}
                  </Text>
                )}
              />
              <Table.Column
                title="Data de postagem"
                key="create_at"
                dataIndex="created_at"
                render={createdAt => <Text>{formatDate(createdAt)}</Text>}
              />
              <Table.Column title="Texto" key="text" dataIndex="text" />
            </Table>
            {record?.status === 'pending' && (
              <Button
                onClick={() => modal.show()}
                style={{ marginTop: '12px' }}
              >
                Nova resposta
              </Button>
            )}
            <PostModal threadId={record.id} modal={modal} onUpdate={onUpdate} />
          </div>
        )}
      </Card>
    </ShowLayout>
  );
};
